import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import ReduceAbsenteeism2 from '../../../components/Satellites/perceptum/ReduceAbsenteeism/ReduceAbsenteeism2/ReduceAbsenteeism2';
import ReduceAbsenteeism3 from '../../../components/Satellites/perceptum/ReduceAbsenteeism/ReduceAbsenteeism3/ReduceAbsenteeism3';
import ReduceAbsenteeism4 from '../../../components/Satellites/perceptum/ReduceAbsenteeism/ReduceAbsenteeism4/ReduceAbsenteeism4';
import ReduceAbsenteeism5 from '../../../components/Satellites/perceptum/ReduceAbsenteeism/ReduceAbsenteeism5/ReduceAbsenteeism5';

class ReduceAbsenteeism extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="reduce_absenteeism" />
        <ServiceBanner {...this.props} page="reduceAbsenteeism" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <ReduceAbsenteeism2 {...this.props} />
        <ReduceAbsenteeism3 {...this.props} />
        <ReduceAbsenteeism4 {...this.props} />
        <ReduceAbsenteeism5 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(ReduceAbsenteeism);
